import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EditorBookPageNumbers.css';
import { coverWithoutSpine } from './../../helpers/coverHelper';

class EditorBookPageNumbers extends Component {
  constructor(...args) {
    super(...args);
    const { lang } = this.props;
    this.texts = {
      cover: lang.cover_front,
      spine: lang.spine,
      reverse: lang.cover_back,
      page: lang.page_number,
      frontFlyLeaf: lang.frontFlyLeaf,
      backFlyFleaf: lang.backFlyLeaf,
      coverText: lang.cover,
    };
  }


  getOddNumbers = (howLongShouldIGo) => {
    const oddNumbers = [];

    for (let number = 0; number <= howLongShouldIGo; number++) {
      if ((number % 2) === 0) {
        continue;
      }
      oddNumbers.push(number);
    }

    return oddNumbers;
  }

  cover() {
    const {
      reverse,
      spine,
      cover,
      coverText,
    } = this.texts;

    const { coverType } = this.props;


    if (coverWithoutSpine().includes(coverType)) {
      return (
        <div className="cover">
          <p>{coverText}</p>
        </div>
      );
    }

    return (
      <div className="cover">
        <p>{reverse}</p>
        <p>{spine}</p>
        <p>{cover}</p>
      </div>
    );
  }

  frontFlyLeaf = () => (
    <div className="cover">
      <p>{this.texts.frontFlyLeaf}</p>
    </div>
  )

  backFlyFleaf = () => (
    <div className="cover">
      <p>{this.texts.backFlyFleaf}</p>
    </div>
  )

  pages(page, pageNumber) {
    const {
      isCover,
      isBackFlyLeaf,
      isFrontFlyLeaf,
    } = page;


    if (isCover) {
      return this.cover();
    }

    if (isBackFlyLeaf) {
      return this.backFlyFleaf();
    }

    if (isFrontFlyLeaf) {
      return this.frontFlyLeaf();
    }

    return this.pageNumbers(pageNumber);
  }

  pageNumbers(number) {
    const { page } = this.texts;
    const { hasFlyLeaf } = this.props;
    const oddNumbers = this.getOddNumbers(1000);
    const leftNumber = hasFlyLeaf ? oddNumbers[number - 3] : oddNumbers[number - 2];
    const rightNumber = leftNumber + 1;

    return (
      <div className="pages">
        <p>{leftNumber}{page}</p>
        <p>{rightNumber}{page}</p>
      </div>
    );
  }

  renderPages(page, pageNumber, style) {
    return (
      <div className="page-numbers" style={style}>
        {this.pages(page, pageNumber)}
      </div>
    );
  }

  render() {
    const {
      style,
      page,
      pageNumber,
      photoCover,
    } = this.props;

    return this.renderPages(page, pageNumber, style);
  }
}

EditorBookPageNumbers.defaultProps = {
  page: {},
  pageNumber: 0,
  style: {
    width: '1320px',
  },
  photoCover: false,
};

EditorBookPageNumbers.propTypes = {
  pageNumber: PropTypes.number,
  style: PropTypes.object,
  page: PropTypes.object,
  photoCover: PropTypes.bool,
};

export default EditorBookPageNumbers;



// WEBPACK FOOTER //
// ./src/components/editor-book-page-numbers/EditorBookPageNumbers.jsx